import { HttpResponse } from '@angular/common/http';
import {
    ChangeDetectorRef,
    Component,
    EventEmitter,
    Input,
    OnInit,
    Output,
} from '@angular/core';
import { MessageService } from 'primeng/api';
import { DialogService } from 'primeng/dynamicdialog';
import { MarkTransferComponent } from 'src/app/demo/components/staff-management/staff-attendance/mark-transfer/mark-transfer.component';
import { StaffMarkAbsentComponent } from 'src/app/demo/components/staff-management/view-attendance/staff-mark-absent/staff-mark-absent.component';
import { SignInComponent } from 'src/app/demo/components/staff-management/staff-profile/sign-in/sign-in.component';
import { SignOutComponent } from 'src/app/demo/components/staff-management/staff-profile/sign-out/sign-out.component';
import { AbsentStudentsComponent } from 'src/app/demo/components/student-sign-in/daily-absent-students/absent-students.component';
import { MarkAbsentStudComponent } from 'src/app/demo/components/student-sign-in/mark-absent-stud/mark-absent-stud.component';
import { SigninStudentComponent } from 'src/app/demo/components/student-sign-in/mark-attendance/signin-student/signin-student.component';
import { SignoutStudentComponent } from 'src/app/demo/components/student-sign-in/mark-attendance/signout-student/signout-student.component';
import { TransferStudentComponent } from 'src/app/demo/components/student-sign-in/mark-attendance/transfer-student/transfer-student.component';
import { AttendanceDTO } from 'src/app/demo/model/AttendanceDTO';
import { StaffDTO } from 'src/app/demo/model/StaffDTO';
import { StudentDTO } from 'src/app/demo/model/StudentDTO';
import { OperationService } from 'src/app/demo/service/operation.service';
import { LookupService } from 'src/app/demo/service/lookup.service';
import { Common } from 'src/app/demo/utils/common';
import { ActivityDTO } from 'src/app/demo/model/ActivityDTO';
import { ActivityTypeDTO } from 'src/app/demo/model/ActivityTypeDTO';
import { RecordActivityComponent } from 'src/app/demo/components/parent-connection/activities/activity-feed/record-activity/record-activity.component';

@Component({
    selector: 'app-quick-panel',
    templateUrl: './quick-panel.component.html',
    styleUrls: ['./quick-panel.component.scss'],
})
export class QuickPanelComponent implements OnInit {
    @Input() panelType!: 'student' | 'staff' | 'userDetails';
    @Input() quickPanelName: string = '';
    @Output() closeButnClick = new EventEmitter<boolean>();
    @Input() isVisible: boolean = false;
    @Input() userData: any = [];
    selectedMenu: string = 'attendance';
    @Input() selectedStudent: StudentDTO[] = [];
    @Input() selectedStaffs: StaffDTO[] = [];
    @Input() attendanceData: any;
    @Output() studentAttendanceRefresh = new EventEmitter<boolean>();
    @Output() staffAttendanceRefresh = new EventEmitter<boolean>();
    @Output() openMessageDialog = new EventEmitter<{ type: 'student' | 'staff'; users: any[] }>();
    ref: any;
    openExpected: boolean = false;
    unexpectedStudentNames: any;
    attendanceObj: any;
    studentIds: any;
    disableSignInButton: boolean = false;
    disableSignOutBtn: boolean = false;
    disableAbsentBtn: boolean = false;
    disableTransferBtn: boolean = false;
    selectedStudentIds: any;
    selectedStaffIds: any;
    disableActivity: boolean = false;
    search: any = {};
    activityTypes: ActivityTypeDTO[] = [];
    constructor(
        private operationService: OperationService,
        private messageService: MessageService,
        public dialogService: DialogService,
        private cdr: ChangeDetectorRef,
        private lookupService: LookupService,
    ) {}

    ngOnInit(): void {
        if (this.panelType == 'staff') {
            this.selectedMenu = 'attendance';
            this.quickPanelName = 'studstaff';
        } else if (this.panelType == 'userDetails') {
            this.quickPanelName = 'userDetails';
        } else if (this.panelType == 'student') {
            this.selectedMenu = 'attendance';
            this.quickPanelName = 'studstaff';
        }

        this.search['status.equals'] = 'A';
        this.search['schoolId.equals'] = this.userData.schoolId;
        this.search['name.notIn'] = ['ABSENT', 'SIGN-OUT', 'SIGN-IN'];
        Common.removeEmptyFields(this.search);
        this.lookupService
            .queryActivityTypeList(this.search)
            .subscribe((res: HttpResponse<ActivityDTO[]>) => {
                this.activityTypes = res.body ?? [];
                this.activityTypes.forEach((activity) => {
                    switch (activity.name) {
                        case 'BATHROOM':
                            activity.src =
                                'assets/demo/images/act_icons/Bathroom.png';
                            break;
                        case 'INCIDENT':
                            activity.src =
                                'assets/demo/images/act_icons/Incident.png';
                            break;
                        case 'MEAL':
                            activity.src =
                                'assets/demo/images/act_icons/Meal.png';
                            break;
                        case 'MEDICATION':
                            activity.src =
                                'assets/demo/images/act_icons/Medication.png';
                            break;
                        case 'NAP START':
                            activity.src =
                                'assets/demo/images/act_icons/NAP.png';
                            break;
                        case 'NAP END':
                            activity.src =
                                'assets/demo/images/act_icons/NAP.png';
                            break;
                        case 'NOTES':
                            activity.src =
                                'assets/demo/images/act_icons/Notes.png';
                            break;
                        case 'OUTDOOR':
                            activity.src =
                                'assets/demo/images/act_icons/Outdoor.png';
                            break;
                        case 'PHOTO':
                            activity.src =
                                'assets/demo/images/act_icons/Photo.png';
                            break;
                        case 'BOTTLE':
                            activity.src =
                                'assets/demo/images/act_icons/Bottle.png';
                            break;
                        case 'LEARNING':
                            activity.src =
                                'assets/demo/images/act_icons/Learning.png';
                            break;
                        case 'OBSERVATION':
                            activity.src =
                                'assets/demo/images/act_icons/observation.png';
                            break;

                        default:
                            break;
                    }
                    activity.isDisabled = false;
                });
            });
    }
    ngOnChanges() {
        const selectedList =
            this.panelType === 'student'
                ? this.selectedStudent
                : this.selectedStaffs;
        if (!selectedList) return;

        this.selectedStudentIds = this.selectedStudent.map(
            (student) => student.id,
        );
        this.selectedStaffIds = this.selectedStaffs.map((staff) => staff.id);

        const selectedRoomsArray: number[] = this.selectedStudent
            .map((student) => student.roomId)
            .filter((roomId): roomId is number => roomId !== undefined); // Type-safe filter

        let globalSelectedRooms = new Set<number>();

        selectedRoomsArray.forEach((roomId) => globalSelectedRooms.add(roomId));

        const uniqueSelectedRoomsArray = Array.from(globalSelectedRooms);

        setTimeout(() => {
            this.updateButtonStates(selectedList, uniqueSelectedRoomsArray);
        }, 100);
    }
    private updateButtonStates(
        selectedList: (StudentDTO | StaffDTO)[],
        selectedRoomsArray: any[],
    ) {
        // Sign In Button Conditions - Modified to allow sign-in for absent students
        this.disableSignInButton = selectedList.some(
            (student) =>
                student.isSignedIn === true || student.profileStatus !== 'A',
        );

        // Sign Out Button Conditions
        this.disableSignOutBtn = selectedList.some(
            (student) =>
                student.isAbsent === true ||
                student.isSignedIn === false ||
                student.profileStatus !== 'A',
        );

        // Transfer Button Conditions
        this.disableTransferBtn = selectedList.some(
            (student) =>
                student.isAbsent === true ||
                student.isSignedIn === false ||
                student.profileStatus !== 'A',
        );

        // Absent Button Conditions
        this.disableAbsentBtn = selectedList.some(
            (student) =>
                student.isAbsent === true ||
                student.isSignedIn === true ||
                student.profileStatus !== 'A' ||
                student.isPresentToday,
        );

        if (selectedRoomsArray.length > 1) {
            this.activityTypes.forEach((activity) => {
                activity.isDisabled = true;
            });
        } else {
            let search: any = {};
            search['roomId.equals'] = selectedRoomsArray[0];
            search['status.equals'] = 'A';
            search['schoolId.equals'] = this.userData.schoolId;
            Common.removeEmptyFields(search);
            this.lookupService
                .queryActivityTypeList(search)
                .subscribe((res: HttpResponse<ActivityTypeDTO[]>) => {
                    let tempActivityTypes = res.body ?? [];
                    this.activityTypes.forEach((activity) => {
                        activity.isDisabled = !tempActivityTypes.some(
                            (tempActivity) => tempActivity.id === activity.id,
                        );

                        if (
                            activity.name === 'INCIDENT' &&
                            this.selectedStudent.length > 1
                        ) {
                            activity.disabled = true;
                            activity.isMultipleStudent = true;
                        }

                        if (
                            activity.name == 'NAP START' ||
                            activity.name == 'NAP END'
                        ) {
                            activity.disabled = false;
                            activity.isNapNotGenerated = false;
                            activity.isNapStart = false;
                            activity.isNapEnd = false;
                            activity.isMultipleStudent = false;

                            if (this.selectedStudent.length === 0) {
                                activity.disabled = true;
                                activity.isMultipleStudent = false;
                            } else {
                                // Check nap status for all selected students
                                const napStatuses: string[] = [];
                                this.selectedStudent.forEach((student) => {
                                    napStatuses.push(
                                        student.napStartOrEnd ||
                                            'Not Generated',
                                    );
                                });

                                // Check if all students have the same nap status
                                const allSameStatus = napStatuses.every(
                                    (status) => status === napStatuses[0],
                                );
                                const commonStatus = napStatuses[0];

                                if (!allSameStatus) {
                                    // Different nap statuses - disable both
                                    activity.disabled = true;
                                    activity.isMultipleStudent = true;
                                } else {
                                    // All students have same status - apply normal logic
                                    if (
                                        commonStatus === 'Not Generated' &&
                                        activity.name === 'NAP END'
                                    ) {
                                        activity.disabled = true;
                                        activity.isNapNotGenerated = true;
                                    } else if (
                                        commonStatus === 'Nap Started' &&
                                        activity.name === 'NAP START'
                                    ) {
                                        activity.disabled = true;
                                        activity.isNapStart = true;
                                    } else if (
                                        commonStatus === 'Nap Ended' &&
                                        activity.name === 'NAP END'
                                    ) {
                                        activity.disabled = true;
                                        activity.isNapEnd = true;
                                    }
                                }
                            }
                        }
                    });
                });
        }
        this.cdr.detectChanges();
    }

    openActivity(activity: ActivityDTO) {
        // Transform selected studentDTO to attendanceDTO format
        const attendanceDTOs = this.selectedStudent.map((student) => {
            let attendanceDTO: AttendanceDTO = {
                roomId: student.roomId,
                status: student.status,
                schoolId: student.schoolId,
                studentId: student.id,
                roomName: student.roomName,
                studentName: student.fullName,
                room: student.room,
                profileimg: student.profileimg,
                student: student,
                hasStudentId: true,
            };
            return attendanceDTO;
        });
        let selectedStudents: AttendanceDTO[] = [];
        selectedStudents.push(...attendanceDTOs);
        this.ref = this.dialogService.open(RecordActivityComponent, {
            data: {
                isFromRoom: true,
                selectedActivityType: activity,
                activeTabIndex: 1,
                selectedStudents: selectedStudents,
                openFromOverview: true,
                roomId: this.selectedStudent[0].roomId,
            },
            header: 'Record activity',
            width: '65%',
            contentStyle: { overflow: 'auto' },
            baseZIndex: 10000,
            maximizable: true,
            closable: true,
        });
        this.ref.onClose.subscribe((res: any) => {
            this.studentAttendanceRefresh.emit(true);
            if (res) {
                const keys = Object.keys(res);
                keys.forEach((key) => {
                    if (key == 'status') {
                        if (res.status == '200' || res.status == '201') {
                            this.messageService.add({
                                severity: 'success',
                                life: 3000,
                                summary: 'Success',
                                detail: 'Activity created successfully',
                            });
                        } else if (res.status == '400' || res.status == '404') {
                            this.messageService.add({
                                severity: 'error',
                                life: 3000,
                                summary: 'Error',
                                detail: res.title,
                            });
                        } else if (res.status == '500') {
                            this.messageService.add({
                                severity: 'error',
                                life: 3000,
                                summary: 'Error',
                                detail: res.title,
                            });
                        }
                    }
                });
            }
        });
    }

    setMenu(menu: string) {
        this.selectedMenu = menu;
    }
    onClose() {
        this.closeButnClick.emit(false);
    }
    sendInvitations() {
        const userIds = this.userData.map((u: any) => u.id);

        this.operationService.createInvitationSend(userIds).subscribe({
            next: () => {
                this.messageService.add({
                    severity: 'success',
                    life: 3000,
                    summary: 'Success',
                    detail: 'Invite Resent Successfully.',
                });
                this.onClose();
            },
            error: () => {
                this.messageService.add({
                    severity: 'success',
                    life: 3000,
                    summary: 'Success',
                    detail: 'Invite Resent Successfully.',
                });
                this.onClose();
            },
        });
    }

    openSignIn() {
        const screenWidth = window.innerWidth; // Get the screen width
        let dialogWidth = '60%'; // Default width for larger screens
        if (screenWidth <= 768) {
            dialogWidth = '90%'; // For mobile devices
        } else if (screenWidth <= 1024) {
            dialogWidth = '40%'; // For tablets
        }

        if (this.attendanceData?.formModule == 'Student') {
            // const dialogData = this.loggedStaff;
            const dialogData = '';
            this.ref = this.dialogService.open(SigninStudentComponent, {
                data: {
                    staff: dialogData,
                    isDashboard: true,
                    activeIndex: 1,
                    fromOverView: true,
                    selectedStudents: this.selectedStudent,
                    selectedStudentIds: this.selectedStudentIds,
                },
                header: 'Sign-In',
                width: dialogWidth,
                contentStyle: {
                    'overflow-y': 'auto',
                    'overflow-x': 'hidden',
                    'max-height': '80vh',
                },
                styleClass: 'student-sign-in-dialog',
                baseZIndex: 10000,
            });
            this.ref.onClose.subscribe((res: any) => {
                if (res.openExpected == true) {
                    this.unexpectedStudentNames = res.unexpectedStudentNames;
                    this.attendanceObj = res.attendanceData;
                    this.studentIds = res.studentIds;
                    this.openExpected = true;
                } else {
                    this.messageService.add({
                        severity: res.severity,
                        summary: res.summary,
                        detail: res.detail,
                        life: res.life,
                    });
                    this.studentAttendanceRefresh.emit(true);
                }
            });
        } else if (this.attendanceData?.formModule == 'Staff') {
            const dialogData = '';
            this.ref = this.dialogService.open(SignInComponent, {
                data: {
                    staff: dialogData,
                    formName: 'Staff_SignIn',
                    isDashboard: true,
                    selectedStaffs: this.selectedStaffs,
                    activeIndex: 1,
                    fromOverView: true,
                    selectedStaffIds: this.selectedStaffIds,
                },
                header: 'Sign-In',
                width: dialogWidth,
                contentStyle: {
                    'overflow-y': 'auto',
                    'overflow-x': 'hidden',
                    'max-height': '80vh',
                },
                styleClass: 'staff-sign-in-dialog',
                baseZIndex: 10000,
            });
            this.ref.onClose.subscribe((res: any) => {
                if (res.openExpected == true) {
                    this.openExpected = true;
                    this.unexpectedStudentNames = res.unexpectedStudentNames;
                    this.attendanceObj = res.attendanceData;
                    this.studentIds = res.selectedStaffId;
                } else {
                    this.messageService.add({
                        severity: res.severity,
                        summary: res.summary,
                        detail: res.detail,
                        life: res.life,
                    });
                    this.staffAttendanceRefresh.emit(true);
                }
            });
        }
    }

    openSignOut() {
        const screenWidth = window.innerWidth; // Get the screen width
        let dialogWidth = '60%'; // Default width for larger screens
        if (screenWidth <= 768) {
            dialogWidth = '90%'; // For mobile devices
        } else if (screenWidth <= 1024) {
            dialogWidth = '40%'; // For tablets
        }

        if (this.attendanceData?.formModule == 'Student') {
            // const dialogData = this.loggedStaff;
            const dialogData = '';
            this.ref = this.dialogService.open(SignoutStudentComponent, {
                data: {
                    staff: dialogData,
                    isDashboard: true,
                    activeIndex: 1,
                    fromOverView: true,
                    selectedStudents: this.selectedStudent,
                },
                header: 'Sign-Out',
                width: dialogWidth,
                contentStyle: {
                    'overflow-y': 'auto',
                    'overflow-x': 'hidden',
                    'max-height': '80vh', // optional: prevent dialog from exceeding screen height
                },
                styleClass: 'student-sign-out-dialog',
                baseZIndex: 10000,
            });
            this.ref.onClose.subscribe((res: any) => {
                if (res != undefined) {
                    this.messageService.add({
                        severity: res.severity,
                        summary: res.summary,
                        detail: res.detail,
                        life: res.life,
                    });
                }
                this.studentAttendanceRefresh.emit(true);
            });
        } else if (this.attendanceData?.formModule == 'Staff') {
            const dialogData = '';
            this.ref = this.dialogService.open(SignOutComponent, {
                data: {
                    staff: dialogData,
                    formName: 'Staff_SignIn',
                    isDashboard: true,
                    selectedStaffs: this.selectedStaffs,
                    activeIndex: 1,
                    fromOverView: true,
                },
                header: 'Sign-Out',
                width: dialogWidth,
                contentStyle: {
                    'overflow-y': 'auto',
                    'overflow-x': 'hidden',
                    'max-height': '80vh', // optional: prevent dialog from exceeding screen height
                },
                styleClass: 'staff-sign-out-dialog',
                baseZIndex: 10000,
            });
            this.ref.onClose.subscribe((res: any) => {
                if (res != undefined) {
                    this.messageService.add({
                        severity: res.severity,
                        summary: res.summary,
                        detail: res.detail,
                        life: res.life,
                    });
                    this.staffAttendanceRefresh.emit(true);
                }
            });
        }
    }
    openTransfer() {
        const screenWidth = window.innerWidth; // Get the screen width
        let dialogWidth = '60%'; // Default width for larger screens
        if (screenWidth <= 768) {
            dialogWidth = '90%'; // For mobile devices
        } else if (screenWidth <= 1024) {
            dialogWidth = '40%'; // For tablets
        }

        if (this.attendanceData?.formModule == 'Student') {
            // const dialogData = this.loggedStaff;
            const dialogData = '';
            this.ref = this.dialogService.open(TransferStudentComponent, {
                data: {
                    staff: dialogData,
                    isDashboard: true,
                    activeIndex: 1,
                    fromOverView: true,
                    selectedStudents: this.selectedStudent,
                },
                header: 'Transfer',
                width: dialogWidth,
                contentStyle: {
                    'overflow-y': 'auto',
                    'overflow-x': 'hidden',
                    'max-height': '80vh',
                },
                styleClass: 'student-transfer-dialog',
                baseZIndex: 10000,
            });
            this.ref.onClose.subscribe((res: any) => {
                if (res != undefined) {
                    this.messageService.add({
                        severity: res.severity,
                        summary: res.summary,
                        detail: res.detail,
                        life: res.life,
                    });
                    setTimeout(() => {
                        this.studentAttendanceRefresh.emit(true);
                    }, 500);
                }
            });
        } else if (this.attendanceData?.formModule == 'Staff') {
            const dialogData = '';
            this.ref = this.dialogService.open(MarkTransferComponent, {
                data: {
                    staff: dialogData,
                    formName: 'Staff_SignIn',
                    isDashboard: true,
                    selectedStaffs: this.selectedStaffs,
                    activeIndex: 1,
                    fromOverView: true,
                },
                header: 'Transfer',
                width: dialogWidth,
                contentStyle: {
                    'overflow-y': 'auto',
                    'overflow-x': 'hidden',
                    'max-height': '80vh',
                },
                styleClass: 'staff-transfer-dialog',
                baseZIndex: 10000,
            });
            this.ref.onClose.subscribe((res: any) => {
                if (res != undefined) {
                    this.messageService.add({
                        severity: res.severity,
                        summary: res.summary,
                        detail: res.detail,
                        life: res.life,
                    });
                    this.staffAttendanceRefresh.emit(true);
                }
            });
        }
    }
    openAbsent() {
        const screenWidth = window.innerWidth; // Get the screen width
        let dialogWidth = '60%'; // Default width for larger screens
        if (screenWidth <= 768) {
            dialogWidth = '90%'; // For mobile devices
        } else if (screenWidth <= 1024) {
            dialogWidth = '40%'; // For tablets
        }

        if (this.attendanceData?.formModule == 'Student') {
            // const dialogData = this.loggedStaff;
            const dialogData = '';
            this.ref = this.dialogService.open(MarkAbsentStudComponent, {
                data: {
                    staff: dialogData,
                    isDashboard: true,
                    activeIndex: 1,
                    fromOverView: true,
                    selectedStudents: this.selectedStudent,
                },
                header: 'Mark Absent',
                width: dialogWidth,
                contentStyle: {
                    'overflow-y': 'auto',
                    'overflow-x': 'hidden',
                    'max-height': '80vh',
                },
                styleClass: 'student-absent-dialog',
                baseZIndex: 10000,
            });
            this.ref.onClose.subscribe((res: any) => {
                if (res != undefined) {
                    this.messageService.add({
                        severity: res.severity,
                        summary: res.summary,
                        detail: res.detail,
                        life: res.life,
                    });
                    this.studentAttendanceRefresh.emit(true);
                }
            });
        } else if (this.attendanceData?.formModule == 'Staff') {
            // const dialogData = this.loggedStaff;
            const dialogData = '';
            this.ref = this.dialogService.open(StaffMarkAbsentComponent, {
                data: {
                    staff: dialogData,
                    isDashboard: true,
                    selectedStaffs: this.selectedStaffs,
                    activeIndex: 1,
                    fromOverView: true,
                },
                header: 'Mark Absent',
                width: dialogWidth,
                contentStyle: {
                    'overflow-y': 'auto',
                    'overflow-x': 'hidden',
                    'max-height': '80vh',
                },
                styleClass: 'staff-absent-dialog',
                baseZIndex: 10000,
            });
            this.ref.onClose.subscribe((res: any) => {
                if (res != undefined) {
                    this.messageService.add({
                        severity: res.severity,
                        summary: res.summary,
                        detail: res.detail,
                        life: res.life,
                    });
                }
                this.staffAttendanceRefresh.emit(true);
            });
        }
    }

    buttonDisabled = false;
    onSaveAttendance() {
        this.buttonDisabled = true;
        this.operationService
            .createAttendanceAll(this.attendanceObj, this.studentIds)
            .subscribe(
                (res: HttpResponse<AttendanceDTO>) => {
                    const messages = {
                        severity: 'success',
                        life: 3000,
                        summary: 'Success',
                        detail: `${
                            this.attendanceObj.hasStudentId == true
                                ? 'Student'
                                : 'Staff'
                        } Signed In successfully.`,
                    };
                    this.ref.close(messages);
                    this.openExpected = false;
                    this.studentAttendanceRefresh.emit(true);
                    this.buttonDisabled = false;
                },
                (error) => {
                    this.messageService.add({
                        severity: 'error',
                        life: 3000,
      summary: error.error?.title || 'Error',
      detail: error.error?.detail || error.error?.message || error?.message || 'An error occurred'
                    });
                    this.buttonDisabled = false;
                },
            );
    }

    onMessage(panelType: string) {
        if (panelType == 'student') {
            // ---- OLD CODE (commented — kept for reference) ----
            // const tempData = {
            //     isFromQuickPanel: true,
            //     selectedStudents: this.selectedStudent,
            // };
            // this.ref = this.dialogService.open(ChatUserListComponent, {
            //     header: 'New Message',
            //     data: tempData,
            //     width: '60%',
            //     contentStyle: {},
            //     styleClass: 'custom-chat-dialog',
            //     baseZIndex: 10000,
            //     maximizable: true,
            // });
            // this.ref.onClose.subscribe((flag: any) => {
            //     if (flag) {
            //         this.messageService.add(flag);
            //         this.chatService.triggerSidebarRefresh();
            //     }
            // });
            // ---- NEW CODE — emit to parent to open new-message component ----
            const users = (this.selectedStudent || []).map((s: any) => ({
                id: s.id,
                name: s.fullName,
                photoUuid: s.photoUuid ?? null,
                role: 'Student' as const,
                roomId: s.roomId,
                profileStatus: s.profileStatus || (s.status === 'A' ? 'A' : 'I'),
                guardianIds: s.guardianIds || [],
                roomName: s.roomName || ''
            }));
            this.openMessageDialog.emit({ type: 'student', users });

        } else if (panelType == 'staff') {
            // ---- OLD CODE (commented — kept for reference) ----
            // const tempData = {
            //     isFromQuickPanel: true,
            //     selectedStaffs: this.selectedStaffs,
            // };
            // this.ref = this.dialogService.open(StaffChatUserListComponent, {
            //     header: 'New Message',
            //     data: tempData,
            //     width: '60%',
            //     contentStyle: {},
            //     styleClass: 'custom-chat-dialog',
            //     baseZIndex: 10000,
            //     maximizable: true,
            // });
            // this.ref.onClose.subscribe((flag: any) => {
            //     this.ngOnInit();
            //     if (flag) {
            //         this.messageService.add({
            //             severity: 'success',
            //             life: 3000,
            //             summary: 'Success',
            //             detail: `Message Sent Successfully.`,
            //         });
            //         this.staffChatService.triggerSidebarRefresh();
            //     }
            // });
            // ---- NEW CODE — emit to parent to open new-message component ----
            const users = (this.selectedStaffs || []).map((s: any) => ({
                id: s.id,
                name: s.name,
                photoUuid: s.photoUuid ?? null,
                role: 'Staff' as const,
                roomId: s.primaryRoomId,
                designation: s.designation,
                profileStatus: s.status === 'A' ? 'A' : 'I'
            }));
            this.openMessageDialog.emit({ type: 'staff', users });
        }
    }
    getActivityTooltip(activityType: ActivityTypeDTO): string {
        // if activity is disabled because it is not assigned to classroom
        if (
            activityType.isDisabled == true &&
            this.selectedStudent.length == 1
        ) {
            return 'This activity is not assigned to classroom.';
        }
        // if activity is disabled because selected students are of different classrooms
        if (activityType.isDisabled && this.selectedStudent.length > 1) {
            return "Activity can't be recorded for multiple students of different classrooms.";
        }

        if (activityType.disabled && activityType.isMultipleStudent) {
            // Check if it's an incident activity with multiple students
            if (activityType.name === 'INCIDENT') {
                return 'Incident activities cannot be recorded for multiple students at once.';
            }
            // Block nap activity if students have different nap statuses
            return 'Selected students have different nap statuses.';
        } else if (activityType.disabled && activityType.isNapEnd) {
            // Block nap end activity if nap is already ended
            return 'Nap is already ended.';
        } else if (activityType.disabled && activityType.isNapNotGenerated) {
            // Block nap end activity if nap is not started
            return 'Nap is not started.';
        } else if (activityType.disabled && activityType.isNapStart) {
            // Block nap end activity if nap is already started
            return 'Nap is already started.';
        }
        return '';
    }
}
